export const SET_SELECTED_LANG = 'SET_SELECTED_LANG'

export const setLang = code => ({
  type: SET_SELECTED_LANG,
  payload: code,
})
